import { ThemesDataResolver } from '@b2b/common/resolvers';
import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { PricingListsControllerModule } from './controllers/PricingListsController';

export const PricingListsView = angular
  .module('acme.view.application.pricing.lists', [uiRouter, 'ui.bootstrap', PricingListsControllerModule])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.pricing.lists',
      url: '/lists?id',
      views: {
        'subview-main': {
          controller: 'PricingListsController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/pricing/lists/lists.tpl.html',
        },
      },
      data: {
        pageTitle: 'Pricing',
        permissions: ['PRICE_LISTS_VIEW'],
      },
      resolve: {
        ThemesData: ThemesDataResolver({ includeEmail: true }),
      },
    });
  }).name;
